import { render } from "./Registries.vue?vue&type=template&id=6e84fc43"
import script from "./Registries.vue?vue&type=script&lang=js"
export * from "./Registries.vue?vue&type=script&lang=js"

import "./Registries.vue?vue&type=style&index=0&id=6e84fc43&lang=scss"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__